import React, { useCallback } from 'react';
import { useConversation } from '../../context/ConversationProvider';
import ConversationItem from './ConversationItem';
import './ConversationList.css';


const ConversationList = () => {
  // Use modular context instead of legacy useChat
  const {
    conversations,
    activeConversationId,
    setActiveConversationId,
  } = useConversation();

  // Memoized callback to prevent unnecessary re-renders of ConversationItem children
  const handleSelect = useCallback((id) => {
    setActiveConversationId(id);
  }, [setActiveConversationId]);

  if (!conversations || conversations.length === 0) {
    return (
      <div className="chat-list chat-list--empty">
        <p>No conversations yet.</p>
        <p>Start a new chat from profiles or project pages.</p>
      </div>
    );
  }

  return (
    <div className="chat-list" aria-label="Conversation list">
      {conversations.map(conv => (
        <ConversationItem
          key={conv.id}
          conversation={conv}
          activeConversationId={activeConversationId}
          onSelect={handleSelect}
        />
      ))}
    </div>
  );
};

export default ConversationList;
